module.exports = __webpack_public_path__ + "img/qrcode_page.ae77f6e6.png";